import React, { Component } from 'react';

import CanvasImageUpload from 'components/canvasEditor/image/CanvasImageUpload';
import { ENTITY_TYPE } from 'modules/file/constants';

import { UploadConsumer } from '@hotmart/club-files-ui';

@UploadConsumer(ENTITY_TYPE.CERTIFICATE_IMG)
export default class CanvasInnerImage extends Component {
  render() {
    const { ...props } = this.props;

    return (
      <CanvasImageUpload
        {...props}
        className="text-menu__button--large"
        icon="image"
        toolTip="files.image.insert_image"
      />
    );
  }
}
